// This works in Node.js (with the global 'crypto' module)
// and in all modern browser environments.

export function generateV4UUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      // Uses the built-in, cryptographically secure UUID generator
      return crypto.randomUUID(); 
    }
    
    // Fallback for older environments (see manual example below)
    // **Note:** The fallback uses Math.random(), which is less secure
    // and has a higher chance of collision than crypto.randomUUID().
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  
  const myUUID = generateV4UUID();
  console.log(myUUID); 
  // Example Output: "8881d773-6771-419b-a3d8-5541e2170319"